const hideShipping = document.querySelector('.hideShipping');

if (hideShipping) {
	document.getElementById('Form_ShippingMethodForm_ShippingMethodID_11').parentElement.classList.add('hidden');
}